import React from "react";
import styles from "../tasks/OffSiteTasks.module.css";

export default function OffSiteReceptionTasks() {
    return <div className={styles.Title}>Reception</div>;
}
